import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';

import { environment } from '../../../../../environments/environment';
import { v2ErrorMessage } from '../../../shared/utils/v2-api-response.util';
import { EMPTY_LOAN_LIST_SUMMARY, LoanListFilter, LoanListResult } from '../models/loan.model';

@Injectable({ providedIn: 'root' })
export class LoanReadService {
  private readonly base = `${environment.apiUrl}/api/v2/loans`;

  constructor(private http: HttpClient) { }

  list(filter: LoanListFilter): Promise<LoanListResult> {
    const fallback = 'No se pudo cargar la lista de préstamos';
    return firstValueFrom(this.http.post<any>(`${this.base}/list`, filter))
      .catch(error => {
        throw { status: error && error.status, error: { message: v2ErrorMessage(error && error.error, fallback) } };
      })
      .then(response => {
        if (!response || response.isSuccess === false) {
          throw { error: { message: v2ErrorMessage(response, fallback) } };
        }
        return {
          items: Array.isArray(response.values) ? response.values : [],
          total: Number(response.total) || 0,
          summary: response.summary || { ...EMPTY_LOAN_LIST_SUMMARY },
        };
      });
  }
}
